export default __webpack_public_path__ + "static/media/BaseballIcon.d4d97312.png";